import React, { useContext } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./style.css";

import { MyContext, ListContext } from "./MyContext";

import { DATEPICKER_DATE_DISPLAY } from "./UserSettings";
import { Row } from "react-bootstrap";

const DateOnly = (props) => {
  const { mystate, dispatch } = useContext(MyContext);

  const start = mystate.currentLesson.start;

  const handleDateChange = (e) => {
    dispatch({
      type: "SET_DATE_COMPONENT",
      dateOnly: e,
      maxDateOnly: mystate.maxDateOnly,
    });
  };

  return (
    <>
      <Row noGutters>
        <DatePicker
          selected={mystate.dateOnly}
          dateFormat={DATEPICKER_DATE_DISPLAY}
          onChange={(e) => handleDateChange(e)}
          maxDate={mystate.maxDateOnly}
        />
      </Row>
    </>
  );
};

export default DateOnly;
